import useExchanges from "../../../hooks/useExchanges";
import { Select } from "../../ui/Select"
import React from "react"

export const SelectExchanges = React.memo(({label, name, value, country, onChange, required, isReport}) => {

    const exchanges = useExchanges(country);

    return (
        <div className="form-group">
            <Select
                label={label}
                name={name}
                isReport={isReport}
                required={required}
                value={value}
                onChange={onChange}
                options={exchanges.map((value)=>({ value: value.ExchangeName, display_value: value.ExchangeName }))}
            />
        </div>
    )
})